import React, { useState } from 'react';
// import AddItemSearchItem from '../components/addSearchItems/AddItemSearchItem';
import AddItemSearchItem from 'src/common/refactoredComponents/addItemSearchItem/AddItemSearchItem';
import PriceItemButton from 'src/pages/reportUsage/record/components/priceItems/priceItemButton';
import ItemListView from '../components/itemsList/index';
import PatientDetails from '../components/patientDetails/PatientDetails';
import SummaryMobile from '../components/summary/SummaryMobile';
import Signature from '../components/addSignature/signature';
import { AddAndSearchItemContainer } from '../components/addSearchItems/AddItemSearchItem.styled';
import PriceOverrideButtonContainer from '../components/priceOverride/priceOverrideButtonContainer';
import { useTranslation } from 'react-i18next';
import { isMobileDevice, logErrorToConsole } from 'src/utils/util';
import styled from 'styled-components';
import media, { sizes } from 'src/styles/Media.styled';
import { noPriceErrorMsg } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import { ErrorMsgContainer } from '../components/itemsList/LotSerialQtyInput';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import { SubTitleComponent } from '../components/patientDetails/PatientDetails.styled';
import AccountSection from '../components/changeAccount/AccountSection';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import ReportPaymentIcon from 'src/assets/images/ReportPaymentIcon.svg';
import ReportPaymentDisabledIcon from 'src/assets/images/ReportPaymentDisabled.svg';
import { VISIBLE } from 'src/constants/appConstants';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import { DetailsMainContainer } from 'src/pages/consignmentAdd/components/account/AccountContainer.styled';
import { SurgeryDateViewAndNumber } from 'src/pages/scheduleSurgery/components/details/Details.styled';
import { Title } from 'src/pages/consignmentBilling/components/account/Details.styled';
import Select from 'src/common/refactoredComponents/select/Select';
import { DropdownOption } from 'src/constants/templateConstants';

const HeaderContainer = styled.div`
    maring-right: 1px;
    ${media.mobileDevice`
    maring-right: unset;
    `}
`;

const RecordViewContainerMobile = (props) => {
    const {
        filteredProduct,
        setFilteredProduct,
        isSelected,
        selectedProduct,
        addedProduct,
        optionValue,
        onSearchAddPress,
        buttonList,
        autoCompleteInputChange,
        cancelSearchRequest,
        open,
        setOpen,
        handleOnOpen,
        onSelectItem,
        addItemChange,
        updateSelectedProduct,
        productsList,
        productListLoading,
        successMessage,
        setSuccessMessage,
        toggleHidePricesBtn,
        setToggleHidePricesBtn,
        showHidePricesBtn,
        setShowHidePricesBtn,
        isButtonDisabled,
        priceOverrideClickHandler,
        showBundlefromTableList,
        addedChildProduct,
        selectedChildProduct,
        resetSelectedOrAddedItem,
        priceOverrideReason,
        setPriceOverrideReason,
        setPricingNotes,
        vendorCaseErrorRedirection,
        isAccountCardExpanded,
        setIsAccountCardExpanded,
        handleInputChange,
        priceOverrideReportUsageVisibility,
        accounts,
        accountId,
        AccountTemplate,
        accountValue,
        isAccountsOptionLoading,
        handleSearch,
        handleOnfocus,
        closeKeyBoard,
        usageDetails,
        onBlur,
        countryCode,
        reportPaymentBtnClickHandler,
        reportPaymentTable = false,
        itemsToBePriced,
        showReportPayment,
        patientInformationVisibility,
        patientIdMandatory,
        patientIdVisibility,
        isQtyInvalid,
        isErrorExists,
        reportUsagePatientDetails,
        saveExitBtnClickHandler,
        reportPaymentButtonVisibility,
        numberOfSurgery,
        setNumberOfSurgery,
        surgeryNumberReportUsageVisibility,
        surgeryNumberReportUsageMandatory,
        addItemSearchItem,
        signatureVisibilityUsage
    } = props;

    const { t } = useTranslation();
    const [isPatientDetailsVisible, setPatientDetailsVisible] = useState(true);
    const paddingRight =
        window.innerWidth <= sizes.mobileDevice ? '2px' : '7px';
    return (
        <HeaderContainer>
            <SubTitleComponent>
                {t('reportUsage.recordUsageTitle')}
            </SubTitleComponent>
            {usageDetails?.changeAccountEnabled && (
                <AccountSection
                    isAccountCardExpanded={isAccountCardExpanded}
                    setIsAccountCardExpanded={setIsAccountCardExpanded}
                    handleInputChange={handleInputChange}
                    accounts={accounts}
                    accountId={accountId}
                    AccountTemplate={AccountTemplate}
                    accountValue={accountValue}
                    isAccountsOptionLoading={isAccountsOptionLoading}
                    handleSearch={handleSearch}
                    handleOnfocus={handleOnfocus}
                    closeKeyBoard={closeKeyBoard}
                    onBlur={onBlur}
                    usageDetails={usageDetails}
                />
            )}
            {reportUsagePatientDetails?.length > 0 && (
                <PatientDetails
                    patientDetails={props.patientDetails}
                    setPatientDetails={props.setPatientDetails}
                    usageDetails={props.usageDetails}
                    errForEmptyHrefIdField={props.errForEmptyHrefIdField}
                    setErrForEmptyHrefIdField={props.setErrForEmptyHrefIdField}
                    errForEmptyPatientField={props.errForEmptyPatientField}
                    setErrForEmptyPatientField={
                        props.setErrForEmptyPatientField
                    }
                    countryCode={countryCode}
                />
            )}
            {surgeryNumberReportUsageVisibility === VISIBLE && (
                <CollapsableCard id="reportUsage-recordViewContainerMobile-record-procedureDetails"
                    padding={'20px 24px 4px 21px'}
                    margin={'0px 2px 16px 1px'}
                    fontFamily={'AvenirNextWorld Demi'}
                    // fontWeight={'bold'}
                    title={t('common.procedureDetails')}
                    onClick={() => setPatientDetailsVisible(!isPatientDetailsVisible)}
                    isExpanded={isPatientDetailsVisible}
                    currentActivity                    
                >
                    <DetailsMainContainer>
                        {surgeryNumberReportUsageVisibility === VISIBLE && (
                            <SurgeryDateViewAndNumber isConsignmentAdd={true}>
                                <Title
                                    showAstrisk={
                                        surgeryNumberReportUsageMandatory ===
                                        'YES'
                                            ? true
                                            : false
                                    }
                                >
                                    {t('common.surgeryNumberLabel')}
                                </Title>

                                <Select
                                    id="reportUsage-recordViewContainerMobile-record-surgeryNumberLabel"
                                    value={numberOfSurgery}
                                    options={DropdownOption().numberOfSurgery}
                                    onChange={(count) => {
                                        setNumberOfSurgery(count);
                                    }}
                                    width={
                                        window.innerWidth <= sizes.mobileDevice
                                            ? '100%'
                                            : '200px'
                                    }
                                    smWidth="100%"
                                    xSmWidth="40%"
                                    defaultValue={numberOfSurgery}
                                />
                            </SurgeryDateViewAndNumber>
                        )}
                    </DetailsMainContainer>
                </CollapsableCard>
            )}
            <AddAndSearchItemContainer
                padding={'6px !important'}
                marginLeft={'none'}
                marginLeftInput={'none'}
            >
                <AddItemSearchItem
                    id='reportUsage-recordViewMobile'
                    isReportUsage={true}
                    checkLotSerial={true}   
                    orderType={'ZLC'}
                    buttonList={buttonList}
                    onSearchAddPress={onSearchAddPress}
                    // addItemSearchItem={addItemSearchItem}
                    addItemSearchTerm={addItemSearchItem}
                    selectedProduct={selectedProduct}
                    isSelected={isSelected}
                    addItemPlaceholder={t(
                        'reportUsage.addItems.enterCfnOrItemNumber'
                    )}
                    fontSize={'14px'}
                    fontFamily={'AvenirNextWorld Regular'}
                    color={'#040404'}
                    opacity={'0.9'}
                    placeholderMarginLeft={'-6px'}
                    autoCompleteData={productsList}
                    autoCompleteDataLoading={productListLoading}
                    optionValue={optionValue}
                    optionLabelKey={''}
                    autoCompletePlaceholder={t(
                        'reportUsage.searchItems.searchByItemNameorNumber'
                    )}
                    autoCompleteInputChange={autoCompleteInputChange}
                    onClose={() => {
                        try {
                        setOpen(false);
                        cancelSearchRequest();
                        } catch (error) {
                          logErrorToConsole(error);
                        }
                    }}
                    setOpen={setOpen}
                    onChange={updateSelectedProduct}
                    handleOnOpen={handleOnOpen}
                    open={open}
                    onSelectItem={onSelectItem}
                    addItemChange={addItemChange}
                    succesMessage={successMessage}
                    setSuccesMesssage={setSuccessMessage}
                    filteredProduct={filteredProduct}
                    setFilteredProduct={setFilteredProduct}
                />
            </AddAndSearchItemContainer>
            {filteredProduct?.length > 0 &&
                filteredProduct.some(
                    (item) => item.exclusionStatus === noPriceErrorMsg
                ) && (
                    <ErrorMsgContainer padding={'0 0 10px'}>
                        <AlertMsg
                            message={t(
                                'productValidationMessages.noPriceErrorMsg'
                            )}
                        />
                    </ErrorMsgContainer>
                )}
            <ItemListView
                selectedProduct={selectedProduct}
                addedProduct={addedProduct}
                setShowHidePricesBtn={setShowHidePricesBtn}
                toggleHidePricesBtn={toggleHidePricesBtn}
                setToggleHidePricesBtn={setToggleHidePricesBtn}
                filteredProduct={filteredProduct}
                setFilteredProduct={setFilteredProduct}
                showBundlefromTableList={showBundlefromTableList}
                addedChildProduct={addedChildProduct}
                selectedChildProduct={selectedChildProduct}
                resetSelectedOrAddedItem={resetSelectedOrAddedItem}
                setPriceOverrideReason={setPriceOverrideReason}
                setPricingNotes={setPricingNotes}
                vendorCaseErrorRedirection={vendorCaseErrorRedirection}
            />
            {filteredProduct?.length > 0 && (
                <>
                    <PriceItemButton
                        toggleHidePricesBtn={toggleHidePricesBtn}
                        setToggleHidePricesBtn={setToggleHidePricesBtn}
                        showHidePricesBtn={showHidePricesBtn}
                        tableData={filteredProduct}
                        setFilteredProduct={setFilteredProduct}
                        reportPaymentBtnClickHandler={
                            reportPaymentBtnClickHandler
                        }
                        countryCode={countryCode}
                        patientDetails={props.patientDetails}
                        priceOverrideReportUsageVisibility={
                            priceOverrideReportUsageVisibility
                        }
                        isErrorExists={isErrorExists}
                        saveExitBtnClickHandler={saveExitBtnClickHandler}
                        isReportUsage={true}
                    />

                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            paddingBottom: '10px',
                        }}
                    >
                        {!(
                            priceOverrideReportUsageVisibility === 'NOT_VISIBLE'
                        ) ? (
                            <PriceOverrideButtonContainer
                                btnDisabled={
                                    isButtonDisabled ||
                                    toggleHidePricesBtn !== 'hideBtn'
                                }
                                priceOverrideClickHandler={
                                    priceOverrideClickHandler
                                }
                                priceOverrideReason={priceOverrideReason}
                                show={'flex'}
                            />
                        ) : (
                            window.innerWidth <= sizes.mobileDevice &&
                            priceOverrideReportUsageVisibility ===
                                'NOT_VISIBLE' &&
                            countryCode === COUNTRY_CODE_JAPN && (
                                <>
                                    {reportPaymentButtonVisibility ===
                                        VISIBLE &&
                                        !showReportPayment &&
                                        showHidePricesBtn &&
                                        !reportPaymentTable &&
                                        countryCode === COUNTRY_CODE_JAPN && (
                                            <div>
                                                <Button
                                                    id={'reportUsage-record-reportPaymentButton'}
                                                    isJapan={true}
                                                    show={
                                                        usageDetails?.unidId &&
                                                        usageDetails
                                                            ?.unidSurgeryInfoPage
                                                            ?.deliveredRodItems
                                                            ?.length > 0
                                                            ? true
                                                            : itemsToBePriced
                                                            ? true
                                                            : false
                                                    }
                                                    varient = {
                                                        (
                                                        showHidePricesBtn &&
                                                        !showReportPayment &&
                                                        patientIdVisibility ===
                                                            VISIBLE &&
                                                        patientIdMandatory &&
                                                        patientInformationVisibility ===
                                                            VISIBLE &&
                                                        props.patientDetails
                                                            ?.hrefId &&
                                                        props.patientDetails
                                                            ?.patientFirstName &&
                                                        props.patientDetails
                                                            ?.patientLastName &&
                                                        (isQtyInvalid === true
                                                            ? true
                                                            : false)
                                                        ) ? ButtonStyles?.secondaryWhiteBorder : ButtonStyles?.disabled
                                                    }
                                                    // secondaryWhiteBorder={
                                                    //     showHidePricesBtn &&
                                                    //     !showReportPayment &&
                                                    //     patientIdVisibility ===
                                                    //         VISIBLE &&
                                                    //     patientIdMandatory &&
                                                    //     patientInformationVisibility ===
                                                    //         VISIBLE &&
                                                    //     props.patientDetails
                                                    //         ?.hrefId &&
                                                    //     props.patientDetails
                                                    //         ?.patientFirstName &&
                                                    //     props.patientDetails
                                                    //         ?.patientLastName &&
                                                    //     (isQtyInvalid === true
                                                    //         ? true
                                                    //         : false)
                                                    // }
                                                    width={'160px'}
                                                    mobileWidth={'160px'}
                                                    mobileMargin={
                                                        '15px 0 15px 0px'
                                                    }
                                                    height={'36px'}
                                                    borderRadius={'17px'}
                                                    margin={'5px 10px 0px 10px'}
                                                    boxShadow={
                                                        '0px 0px 2px #00000029'
                                                    }
                                                    fontSize={'14px'}
                                                    // fontFamily={
                                                    //     'AvenirNextWorld Demi'
                                                    // }
                                                    clicked={
                                                        reportPaymentBtnClickHandler
                                                    }
                                                    disabled={
                                                        !(
                                                            patientIdVisibility ===
                                                                VISIBLE &&
                                                            patientIdMandatory &&
                                                            patientInformationVisibility ===
                                                                VISIBLE &&
                                                            props.patientDetails
                                                                ?.hrefId &&
                                                            props.patientDetails
                                                                ?.patientFirstName &&
                                                            props.patientDetails
                                                                ?.patientLastName &&
                                                            (isQtyInvalid ===
                                                            true
                                                                ? true
                                                                : false)
                                                        )
                                                    }
                                                    backgroundColor={
                                                        !(
                                                            patientIdVisibility ===
                                                                VISIBLE &&
                                                            patientIdMandatory &&
                                                            patientInformationVisibility ===
                                                                VISIBLE &&
                                                            props.patientDetails
                                                                ?.hrefId &&
                                                            props.patientDetails
                                                                ?.patientFirstName &&
                                                            props.patientDetails
                                                                ?.patientLastName &&
                                                            (isQtyInvalid ===
                                                            true
                                                                ? true
                                                                : false)
                                                        ) && '#9F9F9F'
                                                    }
                                                    border={
                                                        !(
                                                            patientIdVisibility ===
                                                                VISIBLE &&
                                                            patientIdMandatory &&
                                                            patientInformationVisibility ===
                                                                VISIBLE &&
                                                            props.patientDetails
                                                                ?.hrefId &&
                                                            props.patientDetails
                                                                ?.patientFirstName &&
                                                            props.patientDetails
                                                                ?.patientLastName &&
                                                            (isQtyInvalid ===
                                                            true
                                                                ? true
                                                                : false)
                                                        ) &&
                                                        '0.6000000238418579px solid #A5A5A5'
                                                    }
                                                    color={
                                                        !(
                                                            patientIdVisibility ===
                                                                VISIBLE &&
                                                            patientIdMandatory &&
                                                            patientInformationVisibility ===
                                                                VISIBLE &&
                                                            props.patientDetails
                                                                ?.hrefId &&
                                                            props.patientDetails
                                                                ?.patientFirstName &&
                                                            props.patientDetails
                                                                ?.patientLastName &&
                                                            (isQtyInvalid ===
                                                            true
                                                                ? true
                                                                : false)
                                                        ) && '#FFFFFF'
                                                    }
                                                >
                                                    <img
                                                        src={
                                                            patientIdVisibility ===
                                                                VISIBLE &&
                                                            patientIdMandatory &&
                                                            patientInformationVisibility ===
                                                                VISIBLE &&
                                                            props.patientDetails
                                                                ?.hrefId &&
                                                            props.patientDetails
                                                                ?.patientFirstName &&
                                                            props.patientDetails
                                                                ?.patientLastName &&
                                                            showHidePricesBtn &&
                                                            (isQtyInvalid ===
                                                            true
                                                                ? true
                                                                : false)
                                                                ? ReportPaymentIcon
                                                                : ReportPaymentDisabledIcon
                                                        }
                                                        style={{
                                                            paddingRight:
                                                                paddingRight,
                                                        }}
                                                    />
                                                    {t(
                                                        'procedure.reportPaymentTitle'
                                                    )}
                                                </Button>
                                            </div>
                                        )}{' '}
                                </>
                            )
                        )}
                        {signatureVisibilityUsage=== VISIBLE && <Signature
                            fonstSize={
                                countryCode === COUNTRY_CODE_JAPN &&
                                window.innerWidth <= sizes.mobileDevice &&
                                priceOverrideReportUsageVisibility ===
                                    'NOT_VISIBLE'
                                    ? true
                                    : false
                            }
                            btnDisabled={isButtonDisabled}
                            {...props}
                        />}
                    </div>
                    {filteredProduct.some(
                        (item) => item.basePrice && item.basePrice.length > 0
                    ) && (
                        <div style={{ minHeight: '200px' }}>
                            <SummaryMobile
                                itemTableData={filteredProduct}
                                displayPrice={
                                    props.toggleHidePricesBtn === 'hideBtn'
                                }
                                accountLabel={t(
                                    'reportUsage.summary.accountOwned'
                                )}
                                accountNotBilled={t(
                                    'reportUsage.summary.notBilled'
                                )}
                                isMobile={isMobileDevice()}
                            />
                        </div>
                    )}
                </>
            )}
        </HeaderContainer>
    );
};

export default RecordViewContainerMobile;
